import { MdKeyboardArrowUp } from "react-icons/md";
import { MdOutlineClose } from "react-icons/md";

interface ActivityHeadlineProps {
  activitiesNumber: number;
  isFullScreenVideo?: boolean;
  setIsActivityExpanded?: Function;
  isActivityExpanded?: boolean;
  type: string;
  // handleRedirectionToFullScreen?: () => void;
  trackingId?: string;
}

export const ActivityHeadline = ({
  activitiesNumber,
  isFullScreenVideo = false,
  setIsActivityExpanded,
  isActivityExpanded,
  type = "exp",
  // handleRedirectionToFullScreen,
  trackingId,
}: ActivityHeadlineProps): JSX.Element => {
  const handleExpandActivities = () => {
    setIsActivityExpanded!(true);
  };

  const handleCollapseActivities = () => {
    setIsActivityExpanded!(false);
  };

  return (
    <div
      className={`flex items-center ${
        isFullScreenVideo ? "justify-between" : "justify-center"
      } ${activitiesNumber > 1 ? "p-1" : "p-0.5"}`}
    >
      {activitiesNumber > 1 && (
        <h3 className="flex items-center justify-center h-10 text-sm font-bold text-center text-primary-color">
          {activitiesNumber}
          <span className="ml-1 mr-1 font-bold text-white">{type}</span>
        </h3>
      )}
      {isFullScreenVideo && activitiesNumber > 1 && (
        <div className="flex flex-col items-center w-6 h-6">
          {!isActivityExpanded ? (
            <>
              <div
                className="grid place-items-center"
                onClick={handleExpandActivities}
                role="button"
              >
                <MdKeyboardArrowUp
                  size={32}
                  className="text-[#00F3CD] -my-[8px] "
                />
              </div>
              <span className="text-white text-[8px]">MORE</span>
            </>
          ) : (
            <div
              id={trackingId}
              className="grid place-items-center text-primary-color"
              onClick={handleCollapseActivities}
              role="button"
            >
              <MdOutlineClose size={24} />
            </div>
          )}
        </div>
      )}
    </div>
  );
};
